require('../../modules/es.object.values');
var path = require('../../internals/path');

module.exports = path.Object.values;



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/es/object/values.js